<div class="width-gt-xs flex-col gap-10" data-cy="NewsPage">
    @if (newEntry) {
        <kkm-news-card-large (newsChange)="reloadEntrys()" data-cy="newNewsCard" />
    }
    @if (isLoading()) {
        <mat-spinner class="spinner"></mat-spinner>
    } @else {
        @for (card of newsListe(); track card) {
            <kkm-news-card-large
                [news]="card"
                (newsChange)="reloadEntrys()"
                [showButtons]="isLoggedIn()"
                data-cy="NewsCard" />
        } @empty {
            <mat-card>
                <mat-card-header>
                    <mat-card-title>
                        <span data-cy="NewsTitel">Zur Zeit sind keine Berichte verfügbar.</span>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content> </mat-card-content>
            </mat-card>
        }
    }
</div>

@if (authService.hasRight('new-news')) {
    <button
        mat-fab
        matTooltip="Neuen Beitrag erstellen"
        [ngClass]="'md-fab md-fab-bottom-right' + (deviceScaleService.isMobileOrTablet() ? '-mobile' : '')"
        color="primary"
        aria-label="Add a News"
        (click)="newEntry = !newEntry"
        [disabled]="newEntry"
        data-cy="fabButton">
        <mat-icon>add</mat-icon>
    </button>
}
